module.exports = __webpack_public_path__ + "img/AI_03.e4993d54.jpg";